module.exports = __webpack_public_path__ + "img/pumping-activities-role5.fc08f525.png";